// extracted by mini-css-extract-plugin
export default {"EmbedArticle":"EmbedArticle_EmbedArticle__DMP0q"};